<template>
  <div class="topup-footer">
    <div class="container">
      <div class="topup-footer-main">
        <div class="topup-footer-links">
          <ul>
            <li><a href="http://www.njumobile.pl/warunki-zakupow" rel="noreferrer" target="_blank">warunki zakupów</a></li>
            <li><a href="http://www.njumobile.pl/regulaminy-i-cenniki" rel="noreferrer" target="_blank">regulaminy i cenniki</a></li>
            <li><a href="http://www.njumobile.pl/b/articles/inne/polityka-prywatnosci-nju.pdf" rel="noreferrer" target="_blank">polityka prywatności</a></li>
            <li><a href="http://njumobile-zasieg.wp.pl" rel="noreferrer" target="_blank">mapa zasięgu</a></li>
            <li><a href="http://www.njumobile.pl/mapa-serwisu" rel="noreferrer" target="_blank">mapa serwisu</a></li>
            <li><a href="http://www.njumobile.pl/kontakt-dla-mediow" rel="noreferrer" target="_blank">kontakt dla mediów</a></li>
          </ul>
        </div>
        <div class="topup-footer-icons">
          <ul>
            <li><a href="https://instagram.com/njumobile" target="_blank"><i class="instagram"></i></a></li>
            <li><a href="http://www.facebook.com/njumobile" target="_blank"><i class="fb"></i></a></li>
            <li><a href="http://www.youtube.com/njumobile" target="_blank"><i class="youtube"></i></a></li>
            <li><img alt="award" class="award" src="../../assets/images/gwiazda.svg"></li>
          </ul>
        </div>
        <div class="topup-footer-copyrights">
          <span>© {{ year }} nju.mobile</span>
        </div>
        <div class="topup-footer-up">
          <a href="#" @click.prevent="scrollTop()"><i class="arr-up"></i></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ToolsClass } from '@/common/class/tools.class'

export default {
  name: 'TopupFooter',
  data () {
    return {
      year: ToolsClass.getCurrentYear()
    }
  },
  methods: {
    scrollTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style src="../../assets/scss/footer.scss" lang="scss"></style>
